import { Card, IconButton, Icon, Box, Switch, Tooltip } from "@mui/material";
import { useState, useEffect } from "react";
import DataTable from "../../../../Components/Table/DataTable";
import WDBox from "../../../../MaterialComponents/WDBox";
import moment from "moment";
import AppService from "../../../../Configurations/Appservice";
import TableLoader from "../../../../Components/AppLoader/TableLoader";
import { useNavigate } from "react-router-dom";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useDispatch } from "react-redux";
import { updateScreenTitle } from "../../../../LayoutContainers/AppLayout/redux/AppSlice";

const tableInitialData = {
  columns: [
    { Header: "name", accessor: "name", width: "18%" },
    { Header: "phoneNumber", accessor: "phoneNumber", width: "15%" },
    { Header: "emailId", accessor: "emailId", width: "20%" },
    { Header: "organisationName", accessor: "organisationName", width: "15%" },
    { Header: "admin", accessor: "admin", width: "7%" },
    { Header: "verified", accessor: "verified", width: "10%" },
    { Header: "created date", accessor: "createDateTime", width: "10%" },
    { Header: "edit", accessor: "edit", width: "5%" },
  ],
  rows: [],
};

const tableFilters = [
  {
    accessor: "organisationName",
    type: "LIST",
    labelName: "Organisation",
  },
  {
    accessor: "phoneNumber",
    type: "TEXT",
    labelName: "Phone Number",
  },
];

const CustomerOrganisationUsers = () => {
  const [tableData, setTableData] = useState(tableInitialData);
  const [isLoading, loading] = useState(true);
  const [updatingVerification, setUpdatingVerification] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleVerificationToggle = async (userId, currentValue) => {
    setUpdatingVerification(userId);
    try {
      await AppService.put(`v1/user/${userId}/verification`, null, {
        params: { verified: !currentValue }
      });
      // Refresh the table data
      const params = { type: "CUSTOMER_ORG" };
      const response = await AppService.get("v1/user/byType", { params });
      _generateTableRows(response);
    } catch (error) {
      console.error("Error updating verification status:", error);
    } finally {
      setUpdatingVerification(null);
    }
  };

  const _generateTableRows = (response) => {
    const rows = response.map((item) => ({
      ...item,
      createDateTime: moment.utc(item.createDateTime).local().format("YYYY-MM-DD"),
      admin: item.admin && <CheckBoxIcon color="primary" />,
      verified: (
        <Tooltip title={item.isVerified ? "Verified - Click to unverify" : "Not verified - Click to verify"}>
          <Switch
            checked={item.isVerified || false}
            onChange={() => handleVerificationToggle(item.id, item.isVerified)}
            disabled={updatingVerification === item.id}
            size="small"
            color="success"
          />
        </Tooltip>
      ),
      edit: (
        <IconButton size="small" onClick={() => _navigateUpdateScreen(item.id)}>
          <Icon>edit</Icon>
        </IconButton>
      ),
    }));

    let tableDataDuplicate = { ...tableData };
    tableDataDuplicate.rows = rows;
    setTableData(tableDataDuplicate);
  };

  useEffect(() => {
    dispatch(updateScreenTitle("Customer  Organisation Users"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  useEffect(() => {
    const params = { type: "CUSTOMER_ORG" };
    AppService.get("v1/user/byType", { params })
      .then(_generateTableRows)
      .catch((error) => {})
      .finally(() => {
        loading(false);
      });
  }, []);

  const _navigateToCreateScreen = () => {
    navigate("/ADM-Customer/adm-new-customer-user");
  };

  const _navigateUpdateScreen = (userId) => {
    navigate("/ADM-Customer/adm-edit-customer-user", { state: { userId } });
  };

  if (isLoading) {
    return (
      <WDBox py={1}>
        <Card>
          <TableLoader />
        </Card>
      </WDBox>
    );
  }

  return (
    // <WDBox py={1}>
    //   <Card>
    //     {tableData && (
    //       <DataTable
    //         table={tableData}
    //         tableFilters={tableFilters}
    //         showAddButton={true}
    //         addButtonOnClick={_navigateToCreateScreen}
    //       />
    //     )}
    //   </Card>
    // </WDBox>
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* <Card sx={{ mb: 1, p: 2 }}>{_renderSearchBar()}</Card> */}
      {
        <DataTable
          table={tableData}
          showAddButton={true}
          addButtonOnClick={_navigateToCreateScreen}
        />
      }
    </Box>
  );
};

export default CustomerOrganisationUsers;
